import React from 'react';
import {
  Filler,
  ListItemContainer,
  Rectangle,
  SpaceLoaderContainer,
} from './Loaders.styled';

export const SpaceLoader = () => (
  <SpaceLoaderContainer>
    <Rectangle width={24} height={24} marginRight={8} opacity={0.28} />
    <Rectangle width={110} height={10} opacity={0.72} />
    <Filler />
  </SpaceLoaderContainer>
);

export const ListItemLoader = (props) => (
  <ListItemContainer>
    <Rectangle height={10} {...props} />
  </ListItemContainer>
);

export const ListTitleLoader = () => (
  <ListItemContainer alignRight>
    <Rectangle height={16} width={16} opacity={0.4} />
  </ListItemContainer>
);

export const SectionsLoader = () => (
  <React.Fragment>
    <ListTitleLoader />
    <ListItemLoader width={140} opacity={0.6} />
    <ListItemLoader width={100} opacity={0.5} />
    <ListItemLoader width={106} opacity={0.4} />
    <ListItemLoader width={82} opacity={0.3} />
  </React.Fragment>
);
